export const IMG_SEGMENT_QUERY_RECEIVED='IMG_SEGMENT_QUERY_RECEIVED';
export const IMG_SEGMENT_GET_TASK_CONF_SUCCESS='IMG_SEGMENT_GET_TASK_CONF_SUCCESS';
export const IMG_SEGMENT_GET_TASK_CONF_ERROR='IMG_SEGMENT_GET_TASK_CONF_ERROR';
export const IMG_SEGMENT_GET_CURRENT_QUESTION_SUCCESS='IMG_SEGMENT_GET_CURRENT_QUESTION_SUCCESS';
export const IMG_SEGMENT_GET_CURRENT_QUESTION_ERROR='IMG_SEGMENT_GET_CURRENT_QUESTION_ERROR';
export const IMG_SEGMENT_GET_NEXT_SEGMENT_DATASET_SUCCESS='IMG_SEGMENT_GET_NEXT_SEGMENT_DATASET_SUCCESS';
export const IMG_SEGMENT_GET_NEXT_SEGMENT_DATASET_ERROR='IMG_SEGMENT_GET_NEXT_SEGMENT_DATASET_ERROR';
export const IMG_SEGMENT_OPEN_LIGHTBOX='IMG_SEGMENT_OPEN_LIGHTBOX';
export const IMG_SEGMENT_CLOSE_LIGHTBOX='IMG_SEGMENT_CLOSE_LIGHTBOX';
export const IMG_SEGMENT_UPDATE_ANSWER='IMG_SEGMENT_UPDATE_ANSWER';
export const IMG_SEGMENT_SUBMIT_ERROR='IMG_SEGMENT_SUBMIT_ERROR';
export const IMG_SEGMENT_SUBMIT_SUCCESS='IMG_SEGMENT_SUBMIT_SUCCESS';
export const IMG_SEGMENT_TASK_COMPLETED='IMG_SEGMENT_TASK_COMPLETED';
export const GET_IMG_SEGMENT_DATASETS_SUCCESS='GET_IMG_SEGMENT_DATASETS_SUCCESS';
export const GET_IMG_SEGMENT_DATASETS_ERROR='GET_IMG_SEGMENT_DATASETS_ERROR';


// WEBPACK FOOTER //
// ./src/redux/imgSegment/actionTypes.js